var _desc, _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout1StreamlineUltimate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Logout-1--Streamline-Ultimate.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Logout 1 Streamline Icon: https://streamlinehq.com")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.5h7s1 0 1 1v17s0 1 -1 1h-7s-1 0 -1 -1v-17s0 -1 1 -1",
    fill: "#cee1f6",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5V1.5a1 1 0 0 0 -1 -1h-11a1 1 0 0 0 -1 1v21a1 1 0 0 0 1 1h11a1 1 0 0 0 1 -1V19",
    fill: "none",
    stroke: "#040e2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5 12 -19 0",
    fill: "none",
    stroke: "#040e2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 17 5 -5 -5 -5",
    fill: "none",
    stroke: "#040e2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout1StreamlineUltimate);
export default __webpack_public_path__ + "static/media/Logout-1--Streamline-Ultimate.b4af42b7264b2c6ee0b8c7e71643abec.svg";
export { ForwardRef as ReactComponent };